import { render, staticRenderFns } from "./TaskProgressPanel.vue?vue&type=template&id=2f363167&scoped=true"
import script from "./TaskProgressPanel.vue?vue&type=script&lang=js"
export * from "./TaskProgressPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskProgressPanel.vue?vue&type=style&index=0&id=2f363167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f363167",
  null
  
)

export default component.exports